import Repository from '../Repository';

const url = '/admin/faq';

export default {

    getQuestion(questionId) {
        return Repository.get(`${url}/${questionId}`);
    },

    getQuestions() {
        return Repository.get(`${url}/`);
    },

    createQuestion(payload) {
        return Repository.post(`${url}/`, payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    updateQuestion(questionId, payload) {
        return Repository.post(`${url}/${questionId}`, payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    deleteQuestion(questionId) {
        return Repository.delete(`${url}/${questionId}`)
    }
}
